// extracted by extract-css-chunks-webpack-plugin
module.exports = {"mobile":"t6ANe","desktop":"Xpr9g"};